import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_DISCOUNT_STATE,
});

export const resetMessage = () => ({
  type: types.RESET_DISCOUNT_MESSAGE,
});

export const validateDiscountCode = (code, plan) => ({
  type: types.VALIDATE_DISCOUNT_CODE.REQUEST,
  code,
  plan,
});

export const validateDiscountCodeSuccess = (discountData) => ({
  type: types.VALIDATE_DISCOUNT_CODE.SUCCESS,
  discountData,
});

export const validateDiscountCodeFailure = (error) => ({
  type: types.VALIDATE_DISCOUNT_CODE.FAILURE,
  error,
});

export const applyDiscountCode = (discountCodeId, userId) => ({
  type: types.APPLY_DISCOUNT_CODE.REQUEST,
  discountCodeId,
  userId,
});

export const applyDiscountCodeSuccess = (message) => ({
  type: types.APPLY_DISCOUNT_CODE.SUCCESS,
  message,
});

export const applyDiscountCodeFailure = (error) => ({
  type: types.APPLY_DISCOUNT_CODE.FAILURE,
  error,
});

export const fetchDiscountCodes = () => ({
  type: types.FETCH_DISCOUNT_CODES.REQUEST,
});

export const fetchDiscountCodesSuccess = (discountCodes) => ({
  type: types.FETCH_DISCOUNT_CODES.SUCCESS,
  discountCodes,
});

export const fetchDiscountCodesFailure = (error) => ({
  type: types.FETCH_DISCOUNT_CODES.FAILURE,
  error,
});

export const createDiscountCode = (discountCodeData) => ({
  type: types.CREATE_DISCOUNT_CODE.REQUEST,
  discountCodeData,
});

export const createDiscountCodeSuccess = (discountCode, message) => ({
  type: types.CREATE_DISCOUNT_CODE.SUCCESS,
  discountCode,
  message,
});

export const createDiscountCodeFailure = (error) => ({
  type: types.CREATE_DISCOUNT_CODE.FAILURE,
  error,
});

export const updateDiscountCode = (id, discountCodeData) => ({
  type: types.UPDATE_DISCOUNT_CODE.REQUEST,
  id,
  discountCodeData,
});

export const updateDiscountCodeSuccess = (discountCode, message) => ({
  type: types.UPDATE_DISCOUNT_CODE.SUCCESS,
  discountCode,
  message,
});

export const updateDiscountCodeFailure = (error) => ({
  type: types.UPDATE_DISCOUNT_CODE.FAILURE,
  error,
});

export const deleteDiscountCode = (id) => ({
  type: types.DELETE_DISCOUNT_CODE.REQUEST,
  id,
});

export const deleteDiscountCodeSuccess = (id, message) => ({
  type: types.DELETE_DISCOUNT_CODE.SUCCESS,
  id,
  message,
});

export const deleteDiscountCodeFailure = (error) => ({
  type: types.DELETE_DISCOUNT_CODE.FAILURE,
  error,
});
